import { useQuery } from "react-query"
import ProofOfOwnershipService from "~services/ProofOfOwnershipService"

const useInvalidationReasons = () => {
  return useQuery(
    "invalidations-reasons",
    () => ProofOfOwnershipService.getInvalidationReasons(),
    {
      enabled: false,
      select: data => {
        if (!!data && data.length > 0) {
          return data.filter(el => el !== "EXPIRED")
        }
      },
    }
  )
}

export default useInvalidationReasons
